import type { CrudFilter } from '@refinedev/core';

/**
 * E02 · Unfinished designs — the server-side filter of the drafts the card reads. With a client chosen (the client page's
 * `fixedClientId`, or the header bar's client filter) it is THAT client's drafts only: the card sits on her page, and a
 * draft of another client there would show one client's work on another's page (E57 review F5). With no client chosen,
 * the practice-wide list shows every draft the caller may see.
 */
export const unfinishedDraftFilters = (clientFilterId: string | null | undefined): CrudFilter[] => [
  { field: 'status', operator: 'eq', value: 'draft' },
  ...(clientFilterId ? [{ field: 'userId', operator: 'eq' as const, value: clientFilterId }] : []),
];
